import { Link } from 'wouter';

import { Header } from '~/client/components/Header';
import { Button } from '~/client/components/Primitives';

export function NotFound() {
  return (
    <>
      <Header />
      <main className="app-main center">
        <div className="empty-state">
          <h2>nothing here</h2>
          <p>that link might be wrong, or the poll might've been deleted.</p>
          <div className="row" style={{ justifyContent: 'center', marginTop: 24 }}>
            <Link href="/new">
              <Button variant="primary" size="lg">
                Start a new poll
              </Button>
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
